const MissionIc = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_14602_3297)">
        <rect x="8" y="8" width="40" height="40" rx="20" fill="white" />
        <path
          d="M22.5938 18.4575H23.9609C24.6873 18.4575 25.3281 19.0984 25.3281 19.8247V21.1919H21.2266V19.8247C21.2266 19.0984 21.8247 18.4575 22.5938 18.4575ZM25.3281 22.5591V36.231C25.3281 37 24.6873 37.5981 23.9609 37.5981H18.4922C17.7231 37.5981 17.125 37 17.125 36.231V33.7102C17.125 32.2576 17.5095 30.8049 18.2786 29.5232C18.834 28.5405 19.2185 27.4724 19.3894 26.3188L19.6885 23.7554C19.7739 23.0718 20.3721 22.5591 21.0557 22.5591H25.3281ZM35.0266 22.5591C35.7102 22.5591 36.3083 23.0718 36.3938 23.7554L36.7356 26.3188C36.8638 27.4724 37.2483 28.5405 37.8037 29.5232C38.5728 30.8049 39 32.2576 39 33.7102V36.231C39 37 38.3591 37.5981 37.6328 37.5981H32.1641C31.395 37.5981 30.7969 37 30.7969 36.231V22.5591H35.0266ZM30.7969 19.8247C30.7969 19.0984 31.395 18.4575 32.1641 18.4575H33.5312C34.2576 18.4575 34.8984 19.0984 34.8984 19.8247V21.1919H30.7969V19.8247ZM29.4297 22.5591V29.395H26.6953V22.5591H29.4297Z"
          fill="#223158"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_14602_3297"
          x="0"
          y="0"
          width="56"
          height="56"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_14602_3297"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_14602_3297"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default MissionIc;
